
document.addEventListener("DOMContentLoaded", () => {
    let errorContainer = document.querySelector(".validate-customer__section")
    if(errorContainer) errorContainer = errorContainer.cloneNode(true)

    let main = document.querySelector('main')
    if(!main) return

    [...main.children].forEach(element => {
        main.removeChild(element)
    })

    main.insertAdjacentElement('afterbegin', errorContainer)
    main.style.opacity = 1;
    errorContainer.style.height = '80vh'
})